import { useContext } from 'react';
import ConfigurationContext from '../../context/ConfigurationContext';

export default function FeatureFlagBarrier({ flag, children }) {
	const config = useContext(ConfigurationContext);

	if (config == null || !config.featureFlags.includes(flag)) return null;
	return <>{children}</>;
}